import Animation from './animation'
import * as d3 from 'd3-selection'
import * as decorations from '../decorations'
import { interpolate } from 'd3-interpolate'

/*
 * This animation is used when we have multiple series with a breakdown and
 * the breakdown is removed. The serie's old points move from their current
 * position into the new serie's bar.
 */
class RemoveBreakdownShuffleAnimation extends Animation {

  constructor (options) {
    super(options)
    this.ripple = true
    this.delayFactor = .6
  }

  match (serie) {
    return !this.seriesChanged &&
           !this.chart.previous.layout.breakdown.calculated && // Previously didn't have a calculated breakdown
           this.chart.layout.breakdown.calculated  // Now we do
  }

  _timingScale () {
    return this.previous.scalers.x.groupScale // Use the previous data
  }

  animate (serie, entering, selection, merged, exiting) {
    let self = this
      , labelsConfig = this.labelsConfig

    // Throw the entering nodes in the DOM
    this._insertHidden(entering, serie)

    // The new bar is in the DOM in the correct spot, grab its dimension attrs
    let dim = this._getDimensions(entering)
      , strokeWidth = this.strokeWidth
      , scale = this.previous.scalers.x.groupScale.copy()
                                                 .padding(0)
                                                 .range([Math.max(0, dim.height) + dim.y, dim.y])

    // Fix borders for the exiting nodes
    exiting.each((point, i, all) => {
      // Tell this point it's the top and/or bottom
      point._bottomStack = i === 0
      point._topStack = i === all.length - 1
    })

    exiting.duration(this.timing.duration)
           .delay(this.timing.delay)
           .tween('move', function (d, i, all) {
             let offset = i === all.length - 1 ? 0 : 1
               , container = d3.select(this)
               , rect = container.select('rect')
               , interpolateX = interpolate(rect.attr('x'), dim.x)
               , interpolateY = interpolate(rect.attr('y'), scale(d.rangeId) - offset)
               , interpolateHeight = interpolate(rect.attr('height'), scale.bandwidth() + offset)
               , interpolateWidth = interpolate(rect.attr('width'), dim.width)

             return t => {
               let x = interpolateX(t)
                 , y = interpolateY(t)
                 , width = interpolateWidth(t)
                 , height = interpolateHeight(t)

                rect.attr('y', y)
                rect.attr('height', height)
                rect.attr('x', x)
                rect.attr('width', width)

                container.call(decorations.position, strokeWidth, {x, width, y, height}, labelsConfig)
             }
           })
           .tween('decorations', this.tweeners.decorations)
           .end()
           .then(() => {
             // All bars have moved, we can show the new bar
             entering.style('opacity', 1)
             // And remove all the others
             exiting.selection().remove()
           })
  }

}

export default RemoveBreakdownShuffleAnimation
